export default __webpack_public_path__ + "static/media/edital42024.c07d8c93.pdf";